var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath}),(_vm.showAgentPanel)?_c('AgentSidebar',{attrs:{"title":"Teamio Agent","agentUrl":_vm.agentUrl,"apiKey":_vm.agentApiKey,"siteId":_vm.siteId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }